import React, {useEffect} from 'react';
import {Backdrop, CircularProgress} from "@mui/material";

function Loading() {

  useEffect(() => {
    setTimeout(() => {},2000);
  }, []);

  return (
    <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Loading;